import { useCssModule, ref, computed } from "vue";
import { u as useI18n } from "./index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./index-BNd8MWnO.js";
import { u as useDisabledProp } from "./index-DKxr0Yto.js";
import "./index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import XBadge from "../XBadge.js";
import { X as XIcon } from "./XIcon-U9bwokTN.js";
import XEllipsis from "../XEllipsis.js";
import { u as useFullWidthProp } from "./index-4vIud5LZ.js";
import SearchInput from "../SearchInput.js";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-VvYS6rEj.js";
const { createFullWidthProp } = useFullWidthProp();
const { createDisabledProp } = useDisabledProp();
const { createTestIdProp } = useDataTestIdProp();
const { t } = useI18n();
function createCommomProps() {
  return {
    placeholder: {
      type: String,
      default: () => t("ds.xSelect.actions.select.ellipsis")
    },
    maxVisibleSelectedItems: {
      type: [Number, Boolean],
      default: 1
    },
    createNewItemLabel: {
      type: String,
      default: ""
    },
    maxChipTextSize: {
      type: Number,
      default: 0
    },
    searchable: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: () => t("ds.xSelect.actions.search")
    },
    multiple: {
      type: Boolean,
      default: false
    },
    ...createDisabledProp(),
    ...createFullWidthProp(),
    ...createTestIdProp()
  };
}
const activator = "_activator_crei4_1";
const isMultiple = "_isMultiple_crei4_26";
const placeholder = "_placeholder_crei4_29";
const searchContainer = "_searchContainer_crei4_36";
const valuesContainer = "_valuesContainer_crei4_39";
const multipleItems = "_multipleItems_crei4_49";
const chipItem = "_chipItem_crei4_59";
const singleItem = "_singleItem_crei4_62";
const singleItemText = "_singleItemText_crei4_66";
const isDisabled = "_isDisabled_crei4_72";
const selectedItemsCount = "_selectedItemsCount_crei4_78";
const arrow = "_arrow_crei4_81";
const hasError = "_hasError_crei4_93";
const style0 = {
  activator,
  isMultiple,
  placeholder,
  searchContainer,
  valuesContainer,
  multipleItems,
  chipItem,
  singleItem,
  singleItemText,
  isDisabled,
  selectedItemsCount,
  arrow,
  hasError
};
const { getDisabledClass } = useDisabledProp();
const { setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "SelectActivator",
  components: { XBadge, XIcon, XEllipsis, SearchInput }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    selectedItems: {
      type: [String, Object, Number, Boolean, Array],
      default: ""
    },
    hasError: {
      type: Boolean,
      default: false
    },
    isMenuOpened: {
      type: Boolean,
      default: false
    },
    searchTerm: {
      type: String,
      default: ""
    },
    labelId: {
      type: String,
      default: ""
    },
    uuid: {
      type: String,
      default: ""
    },
    ...createCommomProps()
  },
  emits: ["control", "input:search", "arrow-down", "remove-item"],
  setup(__props, { emit }) {
    const props = __props;
    const $style = useCssModule();
    const activator2 = ref(null);
    const { disabledClass } = getDisabledClass(props);
    const { formatTestId } = setupTestId(props);
    function useMultipleItems() {
      const selectedItemsLength2 = computed(() => {
        var _a;
        return (_a = props.selectedItems) == null ? void 0 : _a.length;
      });
      const canShowItemsCount2 = computed(
        () => props.maxVisibleSelectedItems && !props.createNewItemLabel && selectedItemsLength2.value > props.maxVisibleSelectedItems
      );
      const selectedItemsList2 = computed(() => {
        if (canShowItemsCount2.value) {
          return props.selectedItems.slice(0, props.maxVisibleSelectedItems);
        }
        return props.selectedItems;
      });
      const selectedItemsCountText2 = computed(
        () => `+${selectedItemsLength2.value - props.maxVisibleSelectedItems}`
      );
      function getSelectedItemTestId2(itemValue) {
        return formatTestId(`${itemValue}SelectChip`);
      }
      function truncateItemText2(text) {
        return props.maxChipTextSize && (text == null ? void 0 : text.length) > props.maxChipTextSize ? `${text.slice(0, props.maxChipTextSize)}...` : text;
      }
      return {
        selectedItemsList: selectedItemsList2,
        selectedItemsLength: selectedItemsLength2,
        selectedItemsCountText: selectedItemsCountText2,
        canShowItemsCount: canShowItemsCount2,
        getSelectedItemTestId: getSelectedItemTestId2,
        truncateItemText: truncateItemText2
      };
    }
    const {
      selectedItemsList,
      selectedItemsLength,
      selectedItemsCountText,
      canShowItemsCount,
      getSelectedItemTestId,
      truncateItemText
    } = useMultipleItems();
    const isUniqueSelect = computed(
      () => !props.searchable || !props.isMenuOpened && props.searchable
    );
    const hasSelectedItem = computed(() => {
      return !!props.selectedItems.text || selectedItemsLength.value > 0;
    });
    const hasSelectedItemClass = computed(() => ({
      [$style.hasSelectedItem]: hasSelectedItem.value
    }));
    const activatorClasses = computed(() => ({
      [$style.isMultiple]: props.multiple && hasSelectedItem.value,
      [$style.hasError]: props.hasError,
      ...disabledClass.value
    }));
    const canShowPlaceholder = computed(() => {
      const baseCondition = !hasSelectedItem.value && !props.isMenuOpened;
      const searchableCondition = props.isMenuOpened && !hasSelectedItem.value && !props.searchable;
      return baseCondition || searchableCondition;
    });
    function emitActivatorData(event) {
      emit("control", { event, activator: activator2 });
    }
    function keyboardControl(event) {
      if (event.key === "Enter") {
        emitActivatorData(event);
      } else if (event.key === "ArrowDown") {
        emit("arrow-down", event);
      }
    }
    function handleSearch(event) {
      emit("input:search", event);
    }
    return { __sfc: true, getDisabledClass, setupTestId, props, emit, $style, activator: activator2, disabledClass, formatTestId, useMultipleItems, selectedItemsList, selectedItemsLength, selectedItemsCountText, canShowItemsCount, getSelectedItemTestId, truncateItemText, isUniqueSelect, hasSelectedItem, hasSelectedItemClass, activatorClasses, canShowPlaceholder, emitActivatorData, keyboardControl, handleSearch, XBadge, XIcon, XEllipsis, SearchInput };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { ref: "activator", class: [_setup.$style.activator, _setup.activatorClasses], attrs: { "tabindex": "0", "role": "combobox", "aria-haspopup": "listbox", "aria-labelledby": _vm.labelId, "aria-owns": _vm.uuid, "aria-expanded": _vm.isMenuOpened, "aria-disabled": _vm.disabled, "data-testid": _vm.dataTestid }, on: { "click": (event) => _setup.emitActivatorData(event), "keydown": _setup.keyboardControl } }, [_c("div", { class: _setup.$style.valuesContainer, attrs: { "aria-controls": _vm.uuid } }, [_c("span", { directives: [{ name: "show", rawName: "v-show", value: _setup.canShowPlaceholder, expression: "canShowPlaceholder" }], class: _setup.$style.placeholder, attrs: { "data-testid": _setup.formatTestId("placeholder") } }, [_vm._v(" " + _vm._s(_vm.placeholder) + " ")]), _vm.multiple ? _c("ul", { directives: [{ name: "show", rawName: "v-show", value: !_setup.canShowPlaceholder, expression: "!canShowPlaceholder" }], class: [_setup.$style.multipleItems, _setup.hasSelectedItemClass, _setup.disabledClass] }, [_vm._l(_setup.selectedItemsList, function(item) {
    return _c(_setup.XBadge, { key: item.text, class: _setup.$style.chipItem, attrs: { "tag": "li", "color": "neutral-0", "closable": !(_vm.disabled || (item == null ? void 0 : item.disabled)), "disabled": _vm.disabled || (item == null ? void 0 : item.disabled), "data-testid": _setup.getSelectedItemTestId(item.value) }, on: { "click": function($event) {
      return _setup.emit("remove-item", item);
    } } }, [_vm._v(" " + _vm._s(_setup.truncateItemText(item.text)) + " ")]);
  }), _setup.canShowItemsCount ? _c(_setup.XBadge, { class: _setup.$style.selectedItemsCount, attrs: { "color": "neutral", "disabled": _vm.disabled, "data-testid": _setup.formatTestId("countChip") } }, [_vm._v(" " + _vm._s(_setup.selectedItemsCountText) + " ")]) : _vm._e(), _vm.searchable ? _c("li", { class: _setup.$style.searchContainer }, [_c(_setup.SearchInput, { attrs: { "value": _vm.searchTerm, "show-search": _vm.isMenuOpened, "data-testid": _vm.dataTestid, "search-placeholder": _vm.searchPlaceholder }, on: { "input": _setup.handleSearch } })], 1) : _vm._e()], 2) : _c("div", { directives: [{ name: "show", rawName: "v-show", value: !_setup.canShowPlaceholder, expression: "!canShowPlaceholder" }], class: [_setup.$style.singleItem, _setup.hasSelectedItemClass, _setup.disabledClass] }, [_c(_setup.XEllipsis, { directives: [{ name: "show", rawName: "v-show", value: _setup.isUniqueSelect, expression: "isUniqueSelect" }], class: _setup.$style.singleItemText, attrs: { "data-testid": _setup.formatTestId("value") } }, [_vm._v(" " + _vm._s(_vm.selectedItems.text) + " ")]), _vm.searchable ? _c(_setup.SearchInput, { attrs: { "value": _vm.searchTerm, "show-search": _vm.isMenuOpened, "data-testid": _vm.dataTestid, "search-placeholder": _vm.searchPlaceholder }, on: { "input": _setup.handleSearch } }) : _vm._e()], 1)]), _c("div", { class: _setup.$style.arrow }, [_c(_setup.XIcon, { attrs: { "icon": `chevron-${_vm.isMenuOpened ? "up" : "down"}`, "size": "lg" } })], 1)]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const SelectActivator = __component__.exports;
export {
  SelectActivator as S,
  createCommomProps as c
};
